import VehicleComparisonEquipmentData from "./VehicleComparisonEquipmentData";

export default VehicleComparisonEquipmentData;
